/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

import Approvals from './pages/Approvals.vue';
import Audit from './pages/Audit.vue';
import Configuration from './pages/Configuration.vue';
import Dashboard from './pages/Dashboard.vue';
import ExpenseDetail from './pages/ExpenseDetail.vue';
import Expenses from './pages/Expenses.vue';
import Exports from './pages/Exports.vue';
import ReportDetail from './pages/ReportDetail.vue';
import Reports from './pages/Reports.vue';

export default {
  'expensa-approvals': Approvals,
  'expensa-audit': Audit,
  'expensa-configuration': Configuration,
  'expensa-dashboard': Dashboard,
  'expensa-expense-detail': ExpenseDetail,
  'expensa-expenses': Expenses,
  'expensa-exports': Exports,
  'expensa-report-detail': ReportDetail,
  'expensa-reports': Reports,
};
